import React, { useState } from "react";

import { FileImportIcon } from "../SVGIcons";

interface GeneralUserListActionBarProps {
  onSearch: (keyword: string) => void; // eslint-disable-line no-unused-vars
  onClearSearch: () => void;
  onLimitSetting: () => void;
  onBulkCreateUser: () => void;
  onCreateUser: () => void;
  isViewer?: boolean;
}

const GeneralUserListActionBar: React.FC<GeneralUserListActionBarProps> = ({
  onSearch,
  onClearSearch,
  onLimitSetting,
  onBulkCreateUser,
  onCreateUser,
  isViewer = false,
}) => {
  const [searchKeyword, setSearchKeyword] = useState("");

  const handleSearch = () => {
    onSearch(searchKeyword);
  };

  const handleClearSearch = () => {
    setSearchKeyword("");
    onClearSearch();
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3 flex-1">
        <input
          type="text"
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
          onKeyPress={handleKeyPress}
          style={{ maxWidth: "400px", flex: 1 }}
          className="p-2 text-gray-900 border border-gray-300 rounded bg-gray-50 text-sm focus:ring-blue-500 focus:border-blue-500"
          placeholder="ユーザー名、ログインID、メールアドレスで検索"
        />
        <button
          type="button"
          onClick={handleSearch}
          className="py-2 px-5 text-sm text-white bg-blue-600 border border-blue-600 rounded hover:bg-blue-700 whitespace-nowrap"
        >
          検索
        </button>
        <button
          type="button"
          onClick={handleClearSearch}
          className="py-2 px-4 text-sm font-medium bg-white rounded border border-gray-300 hover:bg-gray-100 whitespace-nowrap"
        >
          クリア
        </button>
      </div>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onLimitSetting}
          disabled={isViewer}
          className={`px-4 py-2 text-sm font-medium rounded-md ${
            isViewer
              ? "bg-gray-100 border border-gray-300 text-gray-400 cursor-not-allowed"
              : "bg-blue-600 text-white hover:bg-green-700"
          }`}
        >
          上限一括設定
        </button>
        <button
          type="button"
          onClick={onBulkCreateUser}
          disabled={isViewer}
          className="px-4 py-2 text-sm font-medium rounded-md flex items-center gap-1"
          style={{
            backgroundColor: isViewer ? "#f3f4f6" : "white",
            border: isViewer ? "1px solid #d1d5db" : "1px solid #f97316",
            color: isViewer ? "#9ca3af" : "#ea580c",
            cursor: isViewer ? "not-allowed" : "pointer",
          }}
          onMouseEnter={(e) => {
            if (!isViewer) e.currentTarget.style.backgroundColor = "#fff7ed";
          }}
          onMouseLeave={(e) => {
            if (!isViewer) e.currentTarget.style.backgroundColor = "white";
          }}
        >
          <FileImportIcon
            style={{
              fill: isViewer ? "#9ca3af" : "#f97316",
              width: 20,
              height: 20,
            }}
          />
          一括ユーザー追加
        </button>
        <button
          type="button"
          onClick={onCreateUser}
          disabled={isViewer}
          className={`px-4 py-2 text-sm font-medium rounded-md ${
            isViewer
              ? "bg-gray-100 border border-gray-300 text-gray-400 cursor-not-allowed"
              : "bg-orange-500 text-white hover:bg-orange-400"
          }`}
        >
          新規ユーザー追加
        </button>
      </div>
    </div>
  );
};

export default GeneralUserListActionBar;
